import { memo, useEffect } from 'react';

import { TrustPilotProps } from './TrustPilotWidget.types';
import './TrustPilotWidget.css';

function TrustPilotWidget({
  templateId = '54ad5defc6454f065c28af8b',
  height = '240px',
  ...rest
}: TrustPilotProps) {
  useEffect(() => {
    if (window?.Trustpilot) {
      window?.Trustpilot.Modules.WidgetManagement.initializeOnPageLoad();
    }
  }, []);

  return (
    <section {...rest}>
      <script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      ></script>
      <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id={templateId}
        data-businessunit-id="67d8453907f885f02f1e2ba4"
        data-style-height={height}
        data-style-width="100%"
        data-theme="dark"
        data-stars="4,5"
        data-review-languages="en"
        data-tags="carousel"
      >
        <a
          href="https://www.trustpilot.com/review/bonanzasocial.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div>
    </section>
  );
}

export default memo(TrustPilotWidget);
